import { GetApiCall } from "./axiosSetup";

export const GET_TOURNAMENTS = '/tournaments/get-tournaments';

export const GetTournaments = async () => GetApiCall(GET_TOURNAMENTS, "https://api.goatspins.com");